<template>
<div class="CreateServicePreview">
  <div class="CreateServicePreview__wrapper" v-for="field of data" :key="field.id">
    <div class="title" v-if="field.field === 'mainTitle'">
      <h2>
        {{field.inputValue}}
      </h2>
    </div>

    <div class="short__description" v-if="field.field === 'shortDescription'">
      <div class="wrapper ">
        <div class="text block" >
          <p>
            {{field.inputValue}}
          </p>
          <div class="btnDownBlocks">
            <div class="d-flex ">
              <v-btn
                large
                color="white"
                outlined
              >
                Добавить в корзину
              </v-btn>
            </div>
            <div>
              <v-btn
                class="background_transparent"
                large
                color="white"
                outlined
              >
                Образец отчета
              </v-btn>
            </div>
          </div>
        </div>
        <div class="image" v-if="mainImage">
          <v-img
            :src="mainImage.mainImageBase64"
            :contain="true"
          />
        </div>
      </div>
    </div>

    <div class="full__description block"  v-if="field.field === 'fullDescription'">
      <div class="text">
        <p>
          {{field.inputValue}}
        </p>
      </div>
    </div>

    <div class="cards block"  v-if="field.field === 'cardTitle'">
      <div class="title">
        <h3>
          {{field.inputValue}}
        </h3>
      </div>
    </div>
    <div class="cards block"   v-if="field.field === 'card'">
      <div class="wrapper" >
        <div class="card" v-for="card of field.cards" :key="card.id">
          <div class="image">
            <v-img
              :src="card.imageBase64"
              :contain="true"
            />
          </div>
          <div class="text">
            {{card.description}}
          </div>
        </div>
      </div>
    </div>

    <div class="consult block" v-if="field.field === 'callBack'">
      <div class="text col-8">
        <p>{{field.inputValue}}</p>
      </div>
      <div class="btnDownBlocks col-4">
        <div class="d-flex ">
          <v-btn
            large
            color="white"
            outlined
          >
            Связаться с менеджером
          </v-btn>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/**
 * Компонент: CreateServicePreview
 * Описание:
 */
export default {
  name: 'CreateServicePreview',

  components: {},

  props: {
    data: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {};
  },

  computed: {
    mainImage() {
      return this.data.find(field => field.field === 'mainImage');
    }
  },

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {},
};
</script>

<style scoped lang="scss">
.CreateServicePreview {
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: self-start;
  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;

  }
  & .title{
    max-width: 950px!important;
  }
  & .block{
    background: white;
    padding: 16px;
    border-radius: 8px;
  }
  & .text{
    font-size: 16px;
    line-height: 24px;
    white-space: pre-wrap;
    & p{
      margin: 0;
    }
  }
  & .short__description{
    & .wrapper{
      display: flex;
      flex-wrap: nowrap;
      gap: 32px;
    }
    & .text{
      padding: 24px;
      max-width: 560px;
      font-size: 16px;
      line-height: 24px;
      & p{
        margin: 0;
        padding-bottom: 20px;
      }
    }
  }
  & .full__description {
    max-width: 780px;
    & .text p{
      line-height: 24px;
    }
  }
  & .btnDownBlocks{
    display: flex;
    flex-wrap: nowrap;
    gap: 16px;
    & .v-btn{
      background: var(--color-blue-500);
      border-radius: 6px;
      height: 100%;
      font-size: 16px;
      padding: 10px 16px;
      ::v-deep span{
        line-height: 24px;
      }
      &.background_transparent{
        background: transparent;
        color: var(--color-blue-500)!important;
      }
    }
  }
  & .image{
    width: 255px;
    height: 255px;
  }
  & .consult{
    display: flex;
    align-items: center;
    gap: 16px;
    justify-content: center;
    max-width: 850px;
    & p{
      margin: 0;
      width: 100%;
    }
  }
  & .cards.block{
    & .wrapper{
      display: flex;
      flex-wrap: nowrap;
      gap: 16px;
      & .card{
        display: flex;
        flex-direction: column;
        align-items: center;
        flex-wrap: nowrap;
        gap: 4px;
        border: 1px solid var(--color-blue-500);
        padding: 16px;
        border-radius: 20px;
        max-width: 275px;
        & .image{
          width: 100%;
          height: 100%;
          padding: 16px;
          max-width: 216px;
          max-height: 172px;
          & .v-image{
            max-width: 216px;
            max-height: 142px;
          }
        }
        & .text{
          width: 100%;
        }
      }
    }

  }
  /* Стили компонента */
}
</style>
